import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7bb40220")

_pushScopeId("data-v-7bb40220")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Try Formal Trading")
const _hoisted_2 = { class: "d-f mt-16 px-20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Place an order at formal trading on live account and get a $1 coupon ")
const _hoisted_4 = { class: "p-12 bg-white br-lg mt-24" }
const _hoisted_5 = { class: "f-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_7 = { colspan: "2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Quick play")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "vs d-ib" }, "VS", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Formal trading")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Profits")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("100%")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Unlimited")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Risk")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("High")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Low")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Predictability")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Low")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("High")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Easy")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_23 = { class: "t-center" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Try Buying $1 Bitcoin ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_21",
      class: "t-center f-xxl f-bold"
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_t, {
        as: "p",
        path: "home_22",
        class: "mr-16"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_Pic, {
        src: "home/coupon$1",
        width: "80",
        height: "56"
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("table", _hoisted_5, [
        _createVNode("tr", null, [
          _hoisted_6,
          _createVNode("td", _hoisted_7, [
            _createVNode(_component_t, { path: "home_23" }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9,
            _createVNode(_component_t, { path: "home_24" }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_25" }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_26" }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_27" }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_28" }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_29" }, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_30" }, {
              default: _withId(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_31" }, {
              default: _withId(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_32" }, {
              default: _withId(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_33" }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("tr", null, [
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_34" }, {
              default: _withId(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_35" }, {
              default: _withId(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _createVNode("td", null, [
            _createVNode(_component_t, { path: "home_36" }, {
              default: _withId(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode(_component_router_link, { to: "/symbol/BTCUSD" }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            as: "button",
            class: "br-lg try mt-24 c-text f-bold",
            path: "home_37"
          }, {
            default: _withId(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
})